/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SummarizeSessionRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/session_messages.pb'
import {SummarizeSessionResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/session_messages.pb'


export const summarizeSession = (request: SummarizeSessionRequest, options?: CashRequestOptions) => post<SummarizeSessionRequest, SummarizeSessionResponse>("/2.0/cash/summarize-session", request, {...options, rejectOnError: true })